import styled from "styled-components"

export const AgreementSectionNumber = styled.p`
  font-weight: bold;
`
